import React, { FC } from 'react';
import { useAuth } from 'react-oidc-context';
import BurgerMenuIcon from './../../../assets/Itv/Burger Menu.svg';
import BurgerMenuIconMobile from './../../../assets/Itv/Burger Menu-mobile.svg';
import ProfileIcon from './../../../assets/Itv/PROFILE.svg';
import RingIcon from './../../../assets/Itv/Ring-icon.svg';
import { Button } from '../../shared/Button';
import { NavLink } from 'react-router-dom';
import { MediaBreakpoint, useBreakpointInfo } from '../../../hooks/useDeviceInfo';
import { joinStrings } from '../../../utils/string';
import { useSignIn } from '../../../hooks/auth';
import { useUserContext } from '../../../providers/UserProvider';
import './ItvSubNav.scss';

export const ItvSubNav: FC<{ urls: { title: string; slug: string }[] }> = ({ urls }) => {
  const { isAuthenticated } = useAuth();
  const signIn = useSignIn();
  const isMobileAndTablet = useBreakpointInfo([MediaBreakpoint.BELOW_MID_DESKTOP]);
  const isMobile = useBreakpointInfo([MediaBreakpoint.MOBILE]);
  const { theme } = useUserContext();
  const handleLogin = (): void => {
    signIn({ theme });
  };

  return (
    <>
      <div className="subnav">
        <ul className="subnav__controls">
          <li className="subnav__control">
            <img src={isMobileAndTablet ? BurgerMenuIconMobile : BurgerMenuIcon} alt="burger menu icon" />
          </li>
          {!isMobileAndTablet && (
            <>
              <li className="subnav__control">
                <img src={RingIcon} alt="ring icon" />
              </li>
              <li className="subnav__control">
                <img src={ProfileIcon} alt="profile icon" />
              </li>
            </>
          )}
        </ul>

        <div className="subnav__actions">
          {isAuthenticated ? (
            <>
              <div className="subnav__action subnav__action--balance">Balance: £50.00</div>
              <Button type="button" className="subnav__action-btn subnav__action-bnt--deposit">
                Deposit
              </Button>
            </>
          ) : (
            <>
              <Button type="button" onClick={handleLogin} className="subnav__action-btn subnav__action-bnt--join">
                Login
              </Button>
              <Button type="button" className="subnav__action-btn subnav__action-bnt--login">
                Join
              </Button>
            </>
          )}
        </div>
      </div>

      {!isMobile && (
        <ul className="subnav-links">
          {urls.map((url, index) => (
            <li key={url.slug}>
              <NavLink
                key={index}
                to={url.slug}
                className={({ isActive }): string =>
                  joinStrings(['subnav-links__link', isActive ? 'subnav-links__link--active' : ''])
                }
              >
                {url.title}
              </NavLink>
            </li>
          ))}
        </ul>
      )}
    </>
  );
};
